

const strip_prefix = id => {
  if (!id || id.length === 0) {
    return null;
  }
  return id[0].split("|")[1];
};

export { strip_prefix };
